import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CrosshairIcon } from '@rsos/assets/icons';
import {
  AIR_AMBULANCE,
  setIsClickable,
} from '@rsos/reduxDataStore/src/features/geoSelection/geoSelectionSlice';
import {
  SelectorBanner,
  TextIconWrapper,
  IconWrapper,
  BannerText,
} from './SelectLocationBanner.styles';

interface GeoSelectionState {
  geoSelection: {
    [AIR_AMBULANCE]: {
      isClickable: boolean;
    };
  };
}

const SelectLocationBanner = memo((): JSX.Element => {
  const dispatch = useDispatch();
  /**
   * @const isAirAmbulanceClickable - Determines if the map is interactive for tracking and recording latitude/longitude coordinates.
   */
  const isAirAmbulanceClickable = useSelector(
    (state: GeoSelectionState) => state.geoSelection[AIR_AMBULANCE].isClickable,
  );
  const handleClick = (): void => {
    dispatch(
      setIsClickable({
        key: AIR_AMBULANCE,
        isClickable: !isAirAmbulanceClickable,
      }),
    );
  };

  return (
    <SelectorBanner
      horizontal
      onClick={handleClick}
      isClicked={isAirAmbulanceClickable}
    >
      <TextIconWrapper horizontal>
        <IconWrapper isClicked={isAirAmbulanceClickable}>
          <CrosshairIcon />
        </IconWrapper>

        {isAirAmbulanceClickable ? (
          <BannerText isClicked={isAirAmbulanceClickable}>
            Click here to cancel location selection
          </BannerText>
        ) : (
          <BannerText isClicked={isAirAmbulanceClickable}>
            Click here to select location on map
          </BannerText>
        )}
      </TextIconWrapper>
    </SelectorBanner>
  );
});

export default SelectLocationBanner;
